// extracted by mini-css-extract-plugin
export default {"container":"PdfViewerComponent_container__th0oZ"};